export const AlarmsEndpoint = {
  LOAD: '/viiu/alarms/load',
  CLOSE_ALARMS: '/viiu/alarms/close-alarms',
  LIST_FOR_IDS: '/viiu/alarms/list-for-ids',
  GROUP_ALARMS: '/viiu/alarms/group-alarms',
  CREATE_TICKET: '/viiu/alarms/create-ticket',
  SAVE_COLUMNS: '/viiu/alarms/save-columns',
  LOAD_TABLE_CONFIG: '/viiu/alarms/load-table-config',
  GET_MEASUREMENT_DATA: '/viiu/alarms/get-measurement-data',
  LOAD_COMPONENTS: '/viiu/alarms/load-components',
};
